
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import SAccProjectContentDialog from "@/components/projects/dialog/SAccProjectContentDialog.vue";
import SAccContributorsBlock from "@/components/projects/SAccContributorsBlock.vue";
import {ProjectDocument} from "@/interfaces/project.interfaces";

@Component({
  components: {SAccContributorsBlock, SAccProjectContentDialog}
})
export default class SAccProjectDetails extends Vue {
  // Les props
  @Prop() private project!: ProjectDocument | null

  // Les propriétés
  public prjname: string = ''
  public description: string = ''
  public isOpen: boolean = false
  public editName: boolean = false
  public editDesc: boolean = false

  // Les propriétés calculées
  // Les hooks
  // Les méthodes surveillées
  @Watch('project')
  public onChangeProject() {
    if (this.project) {
      this.isOpen = this.project.active
      this.prjname = this.project.name
      this.description = this.project.description
      this.editName = false
      this.editDesc = false
    } else {
      this.isOpen = false
      this.prjname = ''
      this.description = ''
    }
  }
  // Les méthodes d'instance
  // Les méthodes statiques
}
